import React from 'react';

const DefaultInspector = ({ /* props */ }) => {
    // Define tabs, fields, and behaviors specific to Switch
    return (
        <div style={{ padding: '1rem' }}>
            Selecciona un componente
        </div>
    );
};

export default DefaultInspector;